import { GetStaticProps } from "next"
import Image from "next/image"
import { Box, Container, Grid, Hidden } from "@mui/material"
import { makeStyles } from "makeStyles"
import Icon from "@mdi/react"
import {
	// mdiCalendarClock,
	mdiStairs,
	mdiWeightKilogram,
	mdiDoorOpen,
	mdiCash,
} from "@mdi/js"

import Help from "containers/CategoryPage/Help"
import BreadCrumbs, { BreadCrumbAncestor } from "components/BreadCrumbs"

import useTranslation from "hooks/useTranslation"

import { getServerTranslations } from "utils/i18n/getServerTranslations"
import { helpCenterBreadCrumb } from "./index"

const useStyles = makeStyles()((theme) => ({
	ul: {
		lineHeight: "120%",
		listStyle: "none",
		marginLeft: 0,
		paddingLeft: "1.7em",
		textIndent: "-1.7em",
	},
	li: {
		lineHeight: "1.5",
		marginTop: "5px",
		[theme.breakpoints.up("sm")]: {
			marginTop: "10px",
		},
	},
}))

const Assembly = () => {
	const { classes } = useStyles()
	const { t } = useTranslation("help")

	const breadCrumb: BreadCrumbAncestor = {
		label: t("assembly"),
		href: "/help/assembly",
	}

	return (
		<Box my={5}>
			<Box style={{ marginTop: "-40px", paddingBottom: "20px" }}>
				<BreadCrumbs breadCrumbsPaths={[helpCenterBreadCrumb]} currentPath={breadCrumb} />
			</Box>
			<Container>
				<Box pb={5} style={{ textAlign: "center", maxWidth: "650px", margin: "auto" }}>
					<h1 style={{ marginTop: "50", marginBottom: 0 }}>{t("assembly")}</h1>
					<p className="h2" style={{ margin: "0" }}>
						{t("professionalAssemblyService")}
					</p>
				</Box>
				<Box my={5}>
					<Grid container spacing={3}>
						<Grid item xs={12} md={6}>
							<div
								style={{
									borderBottom: "1px solid lightgrey",
									paddingBottom: "5px",
								}}
								className="h2"
							>
								<span style={{ borderBottom: "6px solid #7abfac" }}>
									{t("deliveryIncludingAssembly")}
								</span>
							</div>
							<p>{t("deliveryIncludingAssemblyText")}</p>
						</Grid>
						<Grid item xs={12} md={6}>
							<div
								style={{
									margin: "auto",
									textAlign: "center",
									maxWidth: "400px",
								}}
							>
								<Image
									alt="delivery"
									src="https://res.cloudinary.com/safehero/image/upload/v1572510630/HelpCenter/jkyx2fyrkfzzdmu5h4nn.png"
									width={400}
									height={300}
									style={{
										maxWidth: "100%",
										maxHeight: "300px",
										height: "auto",
										objectFit: "contain",
									}}
								/>
							</div>
						</Grid>
						<Hidden mdDown>
							<Grid item xs={12} md={6}>
								<div
									style={{
										margin: "auto",
										textAlign: "center",
										maxWidth: "400px",
									}}
								>
									<Image
										alt="delivery"
										src="https://res.cloudinary.com/safehero/image/upload/v1572510621/HelpCenter/fkvaukawuxaydb0k44cm.png"
										width={400}
										height={300}
										style={{
											maxWidth: "100%",
											maxHeight: "300px",
											height: "auto",
											objectFit: "contain",
										}}
									/>
								</div>
							</Grid>
						</Hidden>
						<Grid item xs={12} md={6}>
							<div
								style={{
									borderBottom: "1px solid lightgrey",
									paddingBottom: "5px",
								}}
								className="h2"
							>
								<span style={{ borderBottom: "6px solid #7abfac" }}>
									{t("pleaseNote")}
								</span>
							</div>
							<p style={{ color: "grey" }}>{t("pleaseNoteText")}</p>
							<ul className={classes.ul}>
								{/* <li className={classes.li}>
									<Box component="span" mr={1}>
										<Icon path={mdiCalendarClock} size="1rem" color="#7abfac" />
									</Box>
									<span>
										Es kann sich die Lieferzeit aus logistischen Gründen um bis
										zu 2-3 Wochen erhöhen
									</span>
								</li> */}
								<li className={classes.li}>
									<Box component="span" mr={1}>
										<Icon path={mdiStairs} size="1.3rem" color="#7abfac" />
									</Box>
									<span>{t("checkTransportRoute")}</span>
								</li>
								<li className={classes.li}>
									<Box component="span" mr={1}>
										<Icon
											path={mdiWeightKilogram}
											size="1.3rem"
											color="#7abfac"
										/>
									</Box>
									<span>{t("checkTransportRouteText1")}</span>
								</li>
								<li className={classes.li}>
									<Box component="span" mr={1}>
										<Icon path={mdiDoorOpen} size="1.3rem" color="#7abfac" />
									</Box>
									<span>{t("checkTransportRouteText2")}</span>
								</li>
								<li className={classes.li}>
									<Box component="span" mr={1}>
										<Icon path={mdiCash} size="1.3rem" color="#7abfac" />
									</Box>
									<span>{t("checkTransportRouteText3")}</span>
								</li>
							</ul>
						</Grid>
						<Hidden mdUp>
							<Grid item xs={12} md={6}>
								<div style={{ margin: "auto", textAlign: "center" }}>
									<Image
										alt="delivery"
										src="https://res.cloudinary.com/safehero/image/upload/v1572510621/HelpCenter/fkvaukawuxaydb0k44cm.png"
										width={400}
										height={300}
										style={{
											maxWidth: "100%",
											height: "auto",
											maxHeight: "300px",
											objectFit: "contain",
										}}
									/>
								</div>
							</Grid>
						</Hidden>
					</Grid>
				</Box>
				<Help />
			</Container>
		</Box>
	)
}

export const getStaticProps: GetStaticProps = async (context) => {
	const props = {
		...(await getServerTranslations(context.locale, [
			"common",
			"countries",
			"languages",
			"help",
			"category",
		])),
	}
	return {
		props,
	}
}

export default Assembly
